import * as Diagram from "../../../../components/diagram";

export const NoDoctorList = {
  label: "未就診名單",
  key: "NoDoctorList",
  path: "FundusAbnormal/NoDoctorList",
  api: "TCS_V_EyesNotVisitList01V",
  render: (options) => <Diagram.FundusAbnormal.NoDoctorList {...options} />,
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "CreateDate", type: "date" },
    { key: "RegionName", type: "string" },
  ],
  columns: [
    {
      key: "CaseID",
      field: "CaseID",
      header: "案件序號",
    },
    {
      key: "PID",
      field: "PID",
      header: "pid",
    },
    {
      key: "RegionName",
      field: "RegionName",
      header: "鄉鎮",
    },
    {
      key: "CreateDate",
      field: "CreateDate",
      header: "匯入日期",
    },
    {
      key: "CaseStatus",
      field: "CaseStatus",
      header: "案件狀態",
    },
  ],
};
